export enum EnumDetailBatchInfo {
  count_all_product = 'Jumlah Produk',
  count_all_qr = 'Total QR',
  create_by = 'Dibuat Oleh',
  create_date = 'Tanggal Dibuat',
  update_by = 'Diunduh Oleh',
  update_date = 'Tanggal Diunduh',
}
